import React, {Component, Fragment} from 'react';
import {getDateYMD} from "../../../../utils/functions";
import {BASE_PATH, STATUS_NAME} from "../../../../wpconfig";
import {NavLink} from "react-router-dom";

class Item extends Component {
	constructor(props) {
		super(props);

    this.state = {
	    url : "admin.php?" + window.location.href.split("?")[1],
	    baseUrl : 'wp-admin/admin.php?page=resource&',
    }
	}

	componentDidUpdate() {
		setTimeout(() => {
			this.setState({
				'url' : "admin.php?" + window.location.href.split("?")[1]
			})
		}, 0);
	}

	// linkDetail = (event) => {
	// 	event.preventDefault()
	//
	// 	window.location.href = "admin.php?" + window.location.href.split("?")[1] + "&record_id=" + this.props.record.resource_id;
	// }

	render() {
		const record = this.props.record;

		let rdb = {
			'scie': {'name': 'SE', 'class': 'btn db-check'},
			'ssci': {'name': 'SS', 'class': 'btn db-check'},
			'ahci': {'name': 'AH', 'class': 'btn db-check'},
			'esci': {'name': 'ES', 'class': 'btn db-check'},
			'scopus': {'name': 'SP', 'class': 'btn db-check'},
			'nature' : { 'name' : 'NA' , 'class' : 'btn db-check'},
			'kci': {'name': 'KC', 'class': 'btn db-check'},
			'kci_great': {'name': 'KG', 'class': 'btn db-check'},
			'kci_can': {'name': 'KD', 'class': 'btn db-check'}
		}

		record.registered_db && record.registered_db.map((db, index) => {
			if (db === 'SCIE') rdb.scie.class += ' checked';
			else if (db === 'SSCI') rdb.ssci.class += ' checked';
			else if (db === 'AHCI') rdb.ahci.class += ' checked';
			else if (db === 'ESCI') rdb.esci.class += ' checked';
			else if (db === 'Scopus') rdb.scopus.class += ' checked';
			else if(db.name === 'Nature Index') rdb.nature.class += ' checked';
			else if (db === 'KCI') rdb.kci.class += ' checked';
			else if (db === 'KCI우수') rdb.kci_great.class += ' checked';
			else if (db === 'KCI후보') rdb.kci_can.class += ' checked';
		})

		if(record.kri_wos) rdb.scie.class += ' kri-verified';
		if(record.kri_scopus) rdb.scopus.class += ' kri-verified';
		if(record.kri_kci) rdb.kci.class += ' kri-verified';

		return (
			<tr>
				<td scope="row">
					<input type="checkbox" className="ml-0" value={record.resource_id}
					       checked={this.props.checked}
					       onChange={this.props.onRecordCheck}/>
				</td>
				<td>{this.props.no}</td>
				<td>{record.resource_id}</td>
				<td>{record.resource_type}</td>
				<td>
					{/*<a href="#" onClick={this.linkDetail}>*/}
					<a href={this.state.url + "&record_id=" + this.props.record.resource_id}>
						<strong>{record.resource_title}</strong></a>
					<span
						className="pl-2 mb-0 text-secondary">{record.volume ? "V." + record.volume : ''}{record.issue ? "(" + record.issue + ")" : ''}</span>
					<p className="mb-0">
						{record.scholar && record.scholar.map((item, index) => {
							let scholar_class = "text-success";
							if (item.scholar_id === 0) scholar_class = "text-danger"

							return (
								<a href={BASE_PATH + this.state.baseUrl + 'ks=name:'+item.author_name} key={index}>
									<strong className={scholar_class}> {item.author_name}</strong>
									<span className={scholar_class}>({item.dept_name ? item.dept_name : ''})
										{record.scholar.length - 1 > index && ','}
								  </span>
								</a>
							)
						})}
					</p>
				</td>
				<td>{record.journal_title}</td>
				<td>{record.author_count}</td>
				<td>{record.publish_year}</td>
				<td className="pl-0 pr-0 ml-0 mr-0">
					{Object.keys(rdb).map((db, index) => {
						return (<span key={index} className={rdb[db].class}>{rdb[db].name}</span>)
					})}
				</td>
				<td>
					{!record.resource_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
						: record.resource_status === 'publish' ?
							<span className="badge badge-item-status badge-success">{STATUS_NAME[record.resource_status]}</span>
							: record.resource_status === 'draft' ?
								<span className="badge badge-item-status badge-warning">{STATUS_NAME[record.resource_status]}</span>
								: record.resource_status === 'trash' ?
									<span className="badge badge-item-status badge-dark">{STATUS_NAME[record.resource_status]}</span>
									: record.resource_status === 'unpublish' ? <span
											className="badge badge-item-status badge-secondary">{STATUS_NAME[record.resource_status]}</span>
										: ''
					}
				</td>
				<td>{getDateYMD(record.input_date)}<br />{getDateYMD(record.modified_date)}</td>
			</tr>
		)
	}
}

export default Item;